// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
.Editor_heading__70XyL {
  position: relative;
  margin: 0;
  width: -moz-fit-content;
  width: fit-content;
  font-family: "Roboto Mono", "Arial", monospace;
  color: #333333;
}
.Editor_heading-has-underline__x0r2z::after {
  position: absolute;
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  background-color: #8000FF;
}

.Editor_heading-1__Cgtr2 {
  font-size: 48px;
  line-height: 150%;
  color: #8000FF;
}

.Editor_heading-2__5kFHv {
  font-size: 26px;
  line-height: 150%;
}

.Editor_heading-3__Ekoke, .Editor_project__Jsjpu .Editor_title__dl1oj * {
  font-size: 20px;
  line-height: 120%;
  font-weight: 500;
}

.Editor_dataInput__nOf6g {
  font-family: "Roboto Mono", "Arial", monospace;
  gap: 8px;
}

.Editor_dataInput__nOf6g .Editor_header__paVCZ {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: flex-start;
}

.Editor_dataInput__nOf6g .Editor_footer__bRaqU {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: flex-end;
}

.Editor_dataInput__nOf6g .Editor_tags__oMnBb {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}

.Editor_dataInput__nOf6g .Editor_inputs__AP45B {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Editor_nav__8Iy0G {
  display: flex;
  flex-direction: column;
  max-width: 400px;
}

.Editor_project__Jsjpu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.Editor_project__Jsjpu .Editor_title__dl1oj * {
  font-weight: 600;
}

.Editor_project__Jsjpu .Editor_button-box__RzliE {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Editor_project__Jsjpu .Editor_button-box__RzliE > * {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.Editor_viewArea__qDljU {
  width: 100%;
  height: 0;
  position: relative;
}

.Editor_viewArea__qDljU canvas {
  position: relative;
}

.Editor_loadPanel__KhD\\+t {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  top: 0;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.Editor_button__Gpmsv {
  right: 0;
  z-index: 1;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/components/base/heading/Heading.module.sass","webpack://./src/assets/styles/components/editor/Editor.module.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;AChBA;EACI,kBAAA;EACA,SAAA;EACA,uBAAA;EAAA,kBAAA;EACA,8CDaS;ECZT,cDES;AEFb;ADEI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBDJC;AEIT;;ADGA;EACI,eAAA;EACA,iBAAA;EACA,cDVK;AEUT;;ADEA;EACI,eAAA;EACA,iBAAA;ACCJ;;ADCA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;ACEJ;;AA/BA;EACI,8CFiBS;EEhBT,QAAA;AAkCJ;;AAhCA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAmCJ;;AAjCA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AAoCJ;;AAlCA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAqCJ;;AAnCA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAsCJ;;AApCA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAuCJ;;AArCA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;AAwCJ;;AAvCA;EAEQ,gBAAA;AAyCR;;AAxCA;EACQ,aAAA;EACA,sBAAA;EACA,QAAA;AA2CR;;AA1CA;EACY,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA6CZ;;AA3CA;EACI,WAAA;EACA,SAAA;EACA,kBAAA;AA8CJ;;AA5CA;EACI,kBAAA;AA+CJ;;AA7CA;EACI,aAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAgDJ;;AA9CA;EACI,QAAA;EACA,UAAA;EACA,kBAAA;AAiDJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@use \"../../../assets/styles/variables\" as *\r\n@use \"../../../assets/styles/mixins\" as mix\r\n\r\n\r\n.heading\r\n    position: relative\r\n    margin: 0\r\n    width: fit-content\r\n    font-family: $fm-primary\r\n    color: $base-black\r\n\r\n    &-has-underline::after\r\n        position: absolute\r\n        display: block\r\n        content: \"\"\r\n        width: 100%\r\n        height: 1px\r\n        background-color: $accent\r\n\r\n\r\n.heading-1\r\n    font-size: 48px\r\n    line-height: 150%\r\n    color: $accent\r\n\r\n.heading-2\r\n    font-size: 26px\r\n    line-height: 150%\r\n\r\n.heading-3\r\n    font-size: 20px\r\n    line-height: 120%\r\n    font-weight: 500","@use \"../../variables\" as *\r\n@use \"../../../../components/base/heading/Heading.module\" as *\r\n\r\n.dataInput\r\n    font-family: $fm-primary\r\n    gap: 8px\r\n\r\n.dataInput .header\r\n    display: flex\r\n    flex-direction: row\r\n    justify-content: start\r\n    align-items: flex-start\r\n\r\n.dataInput .footer\r\n    display: flex\r\n    flex-direction: column //TODO: исправить на row\r\n    justify-content: stretch\r\n    align-items: flex-end //TODO: исправить некоторектное изображение на странице\r\n\r\n.dataInput .tags\r\n    display: flex\r\n    flex-direction: row\r\n    flex-wrap: wrap\r\n    gap: 8px\r\n\r\n.dataInput .inputs\r\n    display: flex\r\n    flex-direction: column\r\n    gap: 8px\r\n\r\n.nav\r\n    display: flex\r\n    flex-direction: column\r\n    max-width: 400px\r\n\r\n.project\r\n    display: flex\r\n    flex-direction: column\r\n    justify-content: space-between\r\n.project .title *\r\n        @extend .heading-3\r\n        font-weight: 600\r\n.project .button-box\r\n        display: flex\r\n        flex-direction: column\r\n        gap: 8px\r\n.project .button-box > *\r\n            display: flex\r\n            flex-direction: row\r\n            justify-content: space-between\r\n            align-items: center\r\n\r\n.viewArea\r\n    width: 100%\r\n    height: 0\r\n    position: relative\r\n\r\n.viewArea canvas\r\n    position: relative\r\n\r\n.loadPanel\r\n    display: flex\r\n    position: absolute\r\n    left: 0\r\n    right: 0\r\n    width: 100%\r\n    height: 100%\r\n    margin: auto\r\n    top: 0\r\n    align-items: center\r\n    justify-content: center\r\n    gap: 5px\r\n\r\n.button\r\n    right: 0\r\n    z-index: 1\r\n    position: absolute"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `Editor_heading__70XyL`,
	"heading-has-underline": `Editor_heading-has-underline__x0r2z`,
	"heading-1": `Editor_heading-1__Cgtr2`,
	"heading-2": `Editor_heading-2__5kFHv`,
	"heading-3": `Editor_heading-3__Ekoke`,
	"project": `Editor_project__Jsjpu`,
	"title": `Editor_title__dl1oj`,
	"dataInput": `Editor_dataInput__nOf6g`,
	"header": `Editor_header__paVCZ`,
	"footer": `Editor_footer__bRaqU`,
	"tags": `Editor_tags__oMnBb`,
	"inputs": `Editor_inputs__AP45B`,
	"nav": `Editor_nav__8Iy0G`,
	"button-box": `Editor_button-box__RzliE`,
	"viewArea": `Editor_viewArea__qDljU`,
	"loadPanel": `Editor_loadPanel__KhD+t`,
	"button": `Editor_button__Gpmsv`
};
export default ___CSS_LOADER_EXPORT___;
